import { IReprocessedClaimsFilters } from "types/claim";

import { toLocalDateParam } from "./bulkAppealFilterParams";

/**
 * CLE-2861 — Reprocessed Claims filters → query params for GET /claims/reprocessed.
 *
 * Only the filters that are set go on the wire: an empty/absent filter means "no filter", and the
 * API rejects an empty string. `view: "all"` is the API default, so it is omitted too. Paging and
 * sort are always sent. Dates use the LOCAL calendar day (see bulkAppealFilterParams), and the
 * recovery statuses are lower-cased — the API takes `fully_recovered`, not `FULLY_RECOVERED`.
 */
export function reprocessedClaimsParams(
  filters: IReprocessedClaimsFilters
): Record<string, string | number> {
  const params: Record<string, string | number> = {
    page: filters.page,
    pageSize: filters.pageSize,
    sortField: filters.sortField,
    sortOrder: filters.sortOrder,
  };
  if (filters.view !== "all") {
    params.view = filters.view;
  }
  if (filters.payerIds.length > 0) {
    params.payerIds = filters.payerIds.join(",");
  }
  if (filters.providerIds.length > 0) {
    params.providerIds = filters.providerIds.join(",");
  }
  if (filters.startDate) {
    params.startDate = toLocalDateParam(filters.startDate);
  }
  if (filters.endDate) {
    params.endDate = toLocalDateParam(filters.endDate);
  }
  if (filters.recoveryStatuses.length > 0) {
    params.recoveryStatuses = filters.recoveryStatuses
      .map((status) => status.toLowerCase())
      .join(",");
  }
  return params;
}
